import { MessageModalObjProps } from "./message-types";

export class MessageModal {
  static deleteData: MessageModalObjProps = {
    title: "Hapus Data",
    description: (
      <>
        Apakah anda yakin untuk menghapus data ini?
        <br />
        Perubahan yang dilakukan tidak dapat dipulihkan
      </>
    ),
  };

  static messageFormChanges = {
    title: "Anda Belum Menyimpan Perubahan",
    description:
      "Apakah Anda  yakin ingin berpindah ke halaman berikutnya tanpa menyimpan perubahan?",
  };
}
